/* global google */
import { fn, get } from '@ember/helper';
import { on } from '@ember/modifier';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { action, computed, set } from '@ember/object';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert, didUpdate } from '@ember/render-modifiers';
import { type Registry as Services, service } from '@ember/service';
import { isTesting, macroCondition } from '@embroider/macros';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { PrismIcon, PrismLoadingBar } from '@mylighthouse/prism-ember';
// @ts-expect-error: Incorrect type
import preventDefault from 'ember-event-helpers/helpers/prevent-default';
import { t } from 'ember-intl';
import { and, not, or } from 'ember-truth-helpers';
import {
  COLOR_BORDER_BASE,
  COLOR_MARKET_INSIGHT_OWN_HOTEL,
  getCssVariableValue,
  OWN_COMPSET,
  SMART_COMPSET,
  SOLDOUT,
} from 'frontend-utils/utils/css-variable';
import { addZoomControls } from 'frontend-utils/utils/google-maps/zoom-control';
import { THEME } from 'frontend-utils/utils/prism/theme';
import cloneDeep from 'lodash.clonedeep';
// @ts-expect-error: Incorrect type
import DarkStarIllustration from 'lumen/assets/images/market-insight/star-icon-dark.svg';
// @ts-expect-error: Incorrect type
import StarIllustration from 'lumen/assets/images/market-insight/star-icon-light.svg';
// @ts-expect-error: Incorrect type
import DarkStarOutlinedIllustration from 'lumen/assets/images/market-insight/star-outlined-dark.svg';
// @ts-expect-error: Incorrect type
import StarOutlinedIllustration from 'lumen/assets/images/market-insight/star-outlined-light.svg';
import GeneralDropdownsDropdownArrowButton from 'lumen/components/general/dropdowns/dropdown-arrow-button';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';
import HotelMarketInsightDemandEvolution from 'lumen/components/hotel/market-insight/demand-evolution';
import HotelMarketInsightTooltipsRateindexIcons from 'lumen/components/hotel/market-insight/tooltips/rateindex-icons';
import {
  getGoogleMapsStyles,
  GOOGLE_MAPS_SHARED_CONFIG,
} from 'lumen/utils/constants/google-maps-constants';
import { DETAIL_PANE_DETAIL_SECTION_CARD_IDS } from 'lumen/utils/constants/market-insight-constants';
import { getHalfColoredMarkerSvg } from 'lumen/utils/map-markers';
import {
  checkIsPrimaryCompset,
  checkIsSmartCompset,
} from 'lumen/utils/market-insight/market-insight-helpers';

interface HotelMarketInsightCityMapSignature {
  Args: {
    currentExtractDate: unknown;
    extractDateIndex: unknown;
    isDetailRequestLoading: unknown;
    isMarketInsightFull: unknown;
    mapData: unknown;
    model: unknown;
    mouseOutMarkerId: unknown;
    mouseOverMarkerId: unknown;
    nbOfAvailableExtractDates: unknown;
    rateIndexDataForCurrentSelection: unknown;
    selectedDay: unknown;
    selectedDayModel: unknown;
    setFocusedDetailSection: unknown;
    shouldWaitToRenderEventMarkers: unknown;
    showAcceptedEvents: unknown;
    showOwnHotel: unknown;
    showPrimaryCompset: unknown;
    showSmartCompset: unknown;
    showSoldouts: unknown;
    toggleMapVisibilityFlag: unknown;
    toggleShowAllEvents: unknown;
    updateExtractDateIndex: unknown;
  };
}

export default class HotelMarketInsightCityMap extends Component<HotelMarketInsightCityMapSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare miHotels: Services['mi-hotels'];
  @service declare miRateindex: Services['mi-rateindex'];
  @service declare miSelections: Services['mi-selections'];
  @service declare theme: Services['theme'];

  @tracked currentlyHoveredEvent = {};
  @tracked currentlyHoveredHotel = {};
  @tracked currentlyHoveredHotelRateIndexModel = null;
  @tracked isDemandEvolutionVisible = true;
  @tracked isGoogleMapsAPIAvailable = true;
  @tracked isMapLegendInitialLoad = true;
  @tracked isMapLegendVisible = true;
  @tracked isMapLoading = null;
  @tracked map = null;

  cleanupZoomControls = (): void => {};
  containerElement = null;

  // `eventMarkerInfoWindow` and `hotelMarkerInfoWindow` are used to store Google Maps infowindow objects (we can't remake these every time - see marker render functions)
  eventMarkerInfoWindow = null;
  // Store all event & hotel Google Maps markers
  eventMarkers = [];
  hotelMarkerInfoWindow = null;
  hotelMarkers = [];
  markerDict = {};

  @computed('args.mapData.geoData')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get geoData() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.mapData?.geoData;
  }

  @computed('args.mapData.gridFeatures')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get gridFeatures() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.mapData?.gridFeatures;
  }

  willDestroy(): void {
    super.willDestroy();

    this.cleanupZoomControls();
  }

  // Note: we used to do this with setStyle, but we use the manual forEach now (we need to be able to update feature colors, without feature properties changing)
  // @ts-expect-error: Incorrect type
  clearMarkers(markersToClear): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (markersToClear.length) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      markersToClear.forEach((marker) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        marker.setMap(null);
      });

      // Cleanup the markerDict
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      markersToClear.forEach((marker) => {
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (this.markerDict[marker.markerDictId]) {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          delete this.markerDict[marker.markerDictId];
        }
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      markersToClear.length = 0;
    }
  }

  // Helper function that will return the correct marker icon settings for a hotel + rateindex
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  static getHotelMarkerIconConfig(
    // @ts-expect-error: Incorrect type
    hotel,
    // @ts-expect-error: Incorrect type
    isOwnHotel,
    // @ts-expect-error: Incorrect type
    rateIndexesForHotel,
    // @ts-expect-error: Incorrect type
    isSmartCompsetShown,
    // @ts-expect-error: Incorrect type
    isPrimaryCompsetShown,
  ) {
    let iconConfig = {
      path: google.maps.SymbolPath.CIRCLE,
      fillOpacity: 1,
      scale: 6,
      strokeWeight: 2,
      strokeColor: getCssVariableValue(COLOR_BORDER_BASE),
    };

    // In these first two cases we don't need to do any compset checks. Handle them separately
    if (isOwnHotel) {
      // @ts-expect-error: Incorrect type
      iconConfig.fillColor = getCssVariableValue(
        COLOR_MARKET_INSIGHT_OWN_HOTEL,
      );
      iconConfig.strokeColor = getCssVariableValue(COLOR_BORDER_BASE);
      iconConfig.strokeWeight = 4;
    } else if (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      rateIndexesForHotel.isRatesSoldOut ||
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      rateIndexesForHotel.isRateIndexSoldOut
    ) {
      // @ts-expect-error: Incorrect type
      iconConfig.fillColor = getCssVariableValue(SOLDOUT);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      const isPrimaryCompset = checkIsPrimaryCompset(hotel);
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      const isSmartCompset = checkIsSmartCompset(hotel);

      // Proof of concept code: check the compset visibility flags as well before deciding the marker config values
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const showSplitMarkers = isPrimaryCompsetShown && isSmartCompsetShown;
      if (showSplitMarkers && isPrimaryCompset && isSmartCompset) {
        iconConfig = {
          // @ts-expect-error: Incorrect type
          url: getHalfColoredMarkerSvg(
            getCssVariableValue(OWN_COMPSET),
            getCssVariableValue(SMART_COMPSET),
          ),
          scaledSize: new google.maps.Size(25, 25),
          // Need to set the anchor here because it's a custom marker. Else it won't appear at the same location as the SymbolPath markers
          anchor: new google.maps.Point(6, 6),
        };
      } else if (isPrimaryCompsetShown && isPrimaryCompset) {
        // @ts-expect-error: Incorrect type
        iconConfig.fillColor = getCssVariableValue(OWN_COMPSET);
      } else if (isSmartCompsetShown && isSmartCompset) {
        // @ts-expect-error: Incorrect type
        iconConfig.fillColor = getCssVariableValue(SMART_COMPSET);
      }
    }

    return iconConfig;
  }

  /**
   * Process each point in a Geometry, regardless of how deep the points may lie.
   * @param {google.maps.Data.Geometry} geometry The structure to process
   * @param {function(google.maps.LatLng)} callback A function to call on each
   *     LatLng point encountered (e.g. Array.push)
   * @param {Object} thisArg The value of 'this' as provided to 'callback' (e.g.
   *     myArray)
   */
  // @ts-expect-error: Incorrect type
  processPoints(geometry, callback, thisArg): void {
    if (geometry instanceof google.maps.LatLng) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      callback.call(thisArg, geometry);
    } else if (geometry instanceof google.maps.Data.Point) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      callback.call(thisArg, geometry.get());
    } else {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      geometry.getArray().forEach((g) => {
        this.processPoints(g, callback, thisArg);
      });
    }
  }

  // Function to handle the styling of the GeoJSON features display on the map
  renderEventMarkers(isUpdate = false): void {
    // Note: we can't do a copy here because this is coming straight from a peekRecord. The result isn't "copyable" using ember copy
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const eventsToRender = this.args.selectedDayModel?.eventsExceptRejected;

    if (!this.isGoogleMapsAPIAvailable || !eventsToRender) {
      return;
    }

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    eventsToRender.forEach((event) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      event.isVisible = true;

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (event.isAccepted && !this.args.showAcceptedEvents) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        event.isVisible = false;
      }
      // ShowAll events is actually about the unaccepted events
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (!event.isAccepted && !this.miSelections.showAllEvents) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        event.isVisible = false;
      }
    });

    if (!isUpdate) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      eventsToRender.forEach((event) => {
        // https://developers.google.com/maps/documentation/javascript/markers#add
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (event.lon && event.lat) {
          const isDarkTheme =
            this.theme.currentTheme === THEME.DARK ||
            this.theme.currentTheme === THEME.HIGH_CONTRAST_DARK;

          const starIcon = {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            url: isDarkTheme ? DarkStarIllustration : StarIllustration,
            anchor: new google.maps.Point(8, 8),
          };

          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          if (!event.isAccepted) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            starIcon.url = isDarkTheme
              ? DarkStarOutlinedIllustration
              : StarOutlinedIllustration;
          }

          const marker = new google.maps.Marker({
            position: {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
              lat: event.lat,
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
              lng: event.lon,
            },
            map: this.map,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            title: `${event.name} - ${event.displayCategory}`,
            icon: starIcon,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            visible: event.isVisible,
          });

          // Give a higher zIndex to "accepted"/"auto-accepted" events => In case of duplicate events, we want those on top for now
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          marker.setZIndex(event.isAccepted ? 30 : 10);

          // Important check: We can't create a new InfoWindow every time. The original DOM node of the querySelector gets removed somewhere...
          // This can result in issues like empty tooltips after changing the selected day
          // The values in the tooltip are updated by setting the currentlyHoveredEvent in the marker mouseover
          if (!this.eventMarkerInfoWindow) {
            // @ts-expect-error: Incorrect type
            this.eventMarkerInfoWindow = new google.maps.InfoWindow({
              content: document.querySelector(
                '.city-map__event-tooltip-selector',
              ),
            });
          }

          // Important check: We can't create a new InfoWindow every time. The original DOM node of the querySelector gets removed somewhere...
          // This can result in issues like empty tooltips after changing the selected day
          // The values in the tooltip are updated by setting the currentlyHoveredEvent in the marker mouseover
          if (!this.eventMarkerInfoWindow) {
            // @ts-expect-error: Incorrect type
            this.eventMarkerInfoWindow = new google.maps.InfoWindow({
              content: document.querySelector(
                '.city-map__event-tooltip-selector',
              ),
            });
          }

          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const context = this;

          marker.addListener('mouseover', function () {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            context.currentlyHoveredEvent = event;
            // @ts-expect-error: Incorrect type
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
            context.eventMarkerInfoWindow.open(this.map, this);
          });

          // assuming you also want to hide the infowindow when user mouses-out
          marker.addListener('mouseout', () => {
            // @ts-expect-error: Incorrect type
            context.currentlyHoveredEvent = null;
            // @ts-expect-error: Incorrect type
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            context.eventMarkerInfoWindow.close();
          });

          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          set(this, `markerDict.${event.id}`, marker);
          // @ts-expect-error: Incorrect type
          this.eventMarkers.push(marker);
        }
      });
    } else {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      eventsToRender.forEach((event) => {
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (this.markerDict && this.markerDict[event.id]) {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          this.markerDict[event.id].setVisible(event.isVisible);

          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          this.markerDict[event.id].setZIndex(event.isAccepted ? 30 : 10);
        }
      });
    }
  }

  // When this is called (selecting new day or changing extract data) we loop over all features, determine the right color & update the required styles
  renderHotelMarkers(isUpdate = false): void {
    // Used this to pass it mouseover eventListener of the markers
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this;

    // @ts-expect-error: Incorrect type
    if (!this.miHotels.originalGridResponse || !this.isGoogleMapsAPIAvailable) {
      return;
    }

    // Take a copy of the originalGridResponse for now. Think we might need to add some properties here & I don't want to change the original grid response
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const hotelsToRender = cloneDeep(this.miHotels.originalGridResponse);

    // Decide which hotels we need to render depending on all the visibility flags
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    hotelsToRender.forEach((hotel) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      hotel.isVisible = false;
      let isHotelSoldout = false;

      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const { isOwnHotel } = hotel;

      if (isOwnHotel && this.args.showOwnHotel) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        hotel.isVisible = true;
      }

      if (this.args.rateIndexDataForCurrentSelection) {
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
        const rateIndexesForHotel = this.miRateindex.getRateIndexesForHotel(
          this.args.rateIndexDataForCurrentSelection,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          hotel.our_hotel_id,
        );
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        isHotelSoldout =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          rateIndexesForHotel.isRatesSoldOut ||
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          rateIndexesForHotel.isRateIndexSoldOut;

        if (isHotelSoldout && this.args.showSoldouts) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          hotel.isVisible = true;
        }
      }

      if (!isOwnHotel && !isHotelSoldout) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const isPrimaryCompset = checkIsPrimaryCompset(hotel);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        const isSmartCompset = checkIsSmartCompset(hotel);

        if (isPrimaryCompset && this.args.showPrimaryCompset) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          hotel.isVisible = true;
        }
        if (
          isSmartCompset &&
          this.args.isMarketInsightFull &&
          this.args.showSmartCompset
        ) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          hotel.isVisible = true;
        }
      }
    });

    if (!isUpdate) {
      // All new markers will be created (+ attaching event handlers) if isUpdate is false
      // This should be during the initial render phase.

      if (!this.args.rateIndexDataForCurrentSelection) {
        return;
      }

      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      hotelsToRender.forEach((hotel) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (hotel.lat && hotel.lng) {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
          const rateIndexesForHotel = this.miRateindex.getRateIndexesForHotel(
            this.args.rateIndexDataForCurrentSelection,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            hotel.our_hotel_id,
          );

          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const { isOwnHotel } = hotel;

          const marker = new google.maps.Marker({
            position: {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
              lat: hotel.lat,
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
              lng: hotel.lng,
            },
            map: this.map,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            title: hotel.hotel_name,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            visible: hotel.isVisible,
            // @ts-expect-error: Incorrect type
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            markerDictId: hotel.our_hotel_id,
          });

          const markerIconConfig =
            HotelMarketInsightCityMap.getHotelMarkerIconConfig(
              hotel,
              isOwnHotel,
              rateIndexesForHotel,
              this.args.showSmartCompset,
              this.args.showPrimaryCompset,
            );
          marker.setIcon(markerIconConfig);

          const zIndex = isOwnHotel ? 100 : 10;
          marker.setZIndex(zIndex);

          // Important check: We can't create a new InfoWindow every time. The original DOM node of the querySelector gets removed somewhere...
          // This can result in issues like empty tooltips after changing the selected day
          // The values in the tooltip are updated by setting the currentlyHoveredHotel in the marker mouseover
          if (!this.hotelMarkerInfoWindow) {
            // @ts-expect-error: Incorrect type
            this.hotelMarkerInfoWindow = new google.maps.InfoWindow({
              content: document.querySelector(
                '.city-map__hotel-tooltip-selector',
              ),
            });
          }

          // Normal function to have the correct context to display the tooltip.
          // Pass in the context variable as well, so that we are able to update the currentlyHoveredHotel
          marker.addListener('mouseover', function () {
            // Extra safety check
            if (context.args.rateIndexDataForCurrentSelection) {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              context.currentlyHoveredHotel = hotel;
              // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
              context.currentlyHoveredHotelRateIndexModel =
                // @ts-expect-error: Incorrect type
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                context.miRateindex.getRateIndexesForHotel(
                  context.args.rateIndexDataForCurrentSelection,
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                  hotel.our_hotel_id,
                );
              // @ts-expect-error: Incorrect type
              // eslint-disable-next-line @typescript-eslint/no-unsafe-call
              context.hotelMarkerInfoWindow.open(context.map, this);
            }
          });

          // assuming you also want to hide the infowindow when user mouses-out
          marker.addListener('mouseout', () => {
            // @ts-expect-error: Incorrect type
            context.currentlyHoveredHotel = null;
            context.currentlyHoveredHotelRateIndexModel = null;
            // @ts-expect-error: Incorrect type
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            context.hotelMarkerInfoWindow.close();
          });

          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          set(this, `markerDict.${hotel.our_hotel_id}`, marker);
          // @ts-expect-error: Incorrect type
          this.hotelMarkers.push(marker);
        }
      });
    } else {
      // If we trigger the render as an update, we assume that we already have created markers.
      // We get the rateindex for the selected day + hotel + extract date and redo the marker coloring checks.
      // This allows us to update the marker colors without redrawing them fully (e.g. avoid flashing markers when sliding through the extract dates)

      // Also used for updating visibility of markers when items are toggled in the map legend
      if (!context.args.rateIndexDataForCurrentSelection) {
        return;
      }

      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      hotelsToRender.forEach((hotel) => {
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (this.markerDict && this.markerDict[hotel.our_hotel_id]) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const { isOwnHotel } = hotel;

          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const rateIndexesForHotel =
            // @ts-expect-error: Incorrect type
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            context.miRateindex.getRateIndexesForHotel(
              context.args.rateIndexDataForCurrentSelection,
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              hotel.our_hotel_id,
            );

          const markerIconConfig =
            HotelMarketInsightCityMap.getHotelMarkerIconConfig(
              hotel,
              isOwnHotel,
              rateIndexesForHotel,
              this.args.showSmartCompset,
              this.args.showPrimaryCompset,
            );

          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          this.markerDict[hotel.our_hotel_id].setIcon(markerIconConfig);
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          this.markerDict[hotel.our_hotel_id].setVisible(hotel.isVisible);

          const zIndex = isOwnHotel ? 100 : 10;
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          this.markerDict[hotel.our_hotel_id].setZIndex(zIndex);
        }
      });
    }
  }

  // https://developers.google.com/maps/documentation/javascript/reference/data
  updateFeatureStyles(): void {
    if (this.map) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      this.map.data.forEach((feature) => {
        // Get the id of the feature so that we can lookup the color values in the mapping object
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        const featureId = feature.getProperty('id');
        // Opacity of the hexagon is set in the grid
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        const opacity = feature.getProperty('opacity');

        let color = 'white';

        if (featureId !== undefined) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          if (this.geoData?.data?.[featureId]?.length) {
            // Look up the feature id & select the value for the corresponding extract date via the index
            // (extract dates are sorted from most recent -> older)
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            color = this.geoData.data[featureId][this.args.extractDateIndex];
          }
        }

        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        this.map.data.overrideStyle(feature, {
          fillColor: color,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          fillOpacity: opacity,
          strokeWeight: 0,
          clickable: false,
        });
      });
    }
  }

  /**
   * Update a map's viewport to fit each geometry in a dataset (executed after a GeoJSON has loaded - that file will contain the geometries)
   */
  zoom(): void {
    const bounds = new google.maps.LatLngBounds();

    // Take all heatmap geometry datapoints into account for the map viewport
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.map.data.forEach((feature) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/unbound-method
      this.processPoints(feature.getGeometry(), bounds.extend, bounds);
    });

    // Take all hotel/compset hotels positions into account for the map viewport
    // We've added this in May 2022 since we've introduced isolated hotels (in edge cases own hotel can be way outside of the heatmap area)
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.miHotels.originalGridResponse.forEach((hotel) => {
      this.processPoints(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        new google.maps.LatLng(hotel.lat, hotel.lng),
        // eslint-disable-next-line @typescript-eslint/unbound-method
        bounds.extend,
        bounds,
      );
    });

    // Sets the viewport to contain the given bounds (heatmap + hotel markers)
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.map.fitBounds(bounds);

    // fitBounds is an async function (add listener and remove once done)
    // @ts-expect-error: Incorrect type
    google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
      // Only do the extra map zoom in case we're not dealing with an isolated hotel (otherwise we'll risk not showing most of the heatmap area)
      // @ts-expect-error: Incorrect type
      if (!this.hotelAndMarketService.hotel.hotelinfo.remote) {
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
        const currentZoom = this.map.getZoom();

        if (currentZoom) {
          // @ts-expect-error: Incorrect type
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call
          this.map.setZoom(currentZoom + 1);
        }
      }

      // Do an additional center with the coordinates of the own hotel
      // The fitBounds alone resulted in bad positioning for some smaller markets
      // By doing this center, we're sure that you'll see something relevant at map render
      const ownHotelLatLng = new google.maps.LatLng(
        // @ts-expect-error: Incorrect type
        this.hotelAndMarketService.hotel.hotelinfo.latitude,
        // @ts-expect-error: Incorrect type
        this.hotelAndMarketService.hotel.hotelinfo.longitude,
      );
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.map.setCenter(ownHotelLatLng);
    });
  }

  // Note: this does a full event markers rerender for now
  @action
  onEventMarkerToggleUpdate(): void {
    if (!this.args.isDetailRequestLoading) {
      this.renderEventMarkers(true);
    }
  }

  // This action is called when a visibility flag (that impacts the hotel markers) in the city map legend is triggered
  // Note: tried to handle this as an marker update instead of a full cleanup + rerender
  @action
  onHotelMarkerToggleUpdate(): void {
    if (!this.args.isDetailRequestLoading) {
      this.renderHotelMarkers(true);
    }
  }

  // Note: This is triggered by the did-update render modifier. This means that the extractDateIndex URL parameter has been updated
  @action
  onMapFeaturesDataChanged(): void {
    // When we reset the extractDateIndex to 0 on selected day change, we probably don't know the nbOfAvailableExtractDates yet. Don't update the value in that case
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.args.nbOfAvailableExtractDates !== null && this.geoData?.data) {
      this.updateFeatureStyles();
    }
  }

  @action
  onMarkerRerenderRequired(): void {
    // This will result in a full rerender of hotel & event markers (should be done when the selected day is updated)
    // @ts-expect-error: Incorrect type
    this.currentlyHoveredHotel = null;
    this.currentlyHoveredHotelRateIndexModel = null;

    if (!this.args.isDetailRequestLoading) {
      // Remove all current markers if the selected day is changed
      this.clearMarkers(this.eventMarkers);

      // Note: I think that for now we can assume that the hotels will be the same. The smart compset isn't variable yet.
      // Note 2: If we want to give sold out hotels a different color, we will need to re-render hotel markers anyway
      this.clearMarkers(this.hotelMarkers);

      this.renderHotelMarkers();
      this.renderEventMarkers();
    }
  }

  @action
  onMarkerUpdateRequired(): void {
    // Event markers are more static than hotel markers. Don't change them in this case (extract date index change)
    // Hotel markers can be updated (aka see if we need to update the icon in order to update the color)
    this.renderHotelMarkers(true);
  }

  @action
  renderMap(): void {
    if (macroCondition(isTesting())) {
      return;
    }

    try {
      if (google && google.maps) {
        this.isGoogleMapsAPIAvailable = true;
      }
    } catch {
      this.isGoogleMapsAPIAvailable = false;
      return;
    }

    // @ts-expect-error: Incorrect type
    this.isMapLoading = true;

    // Coordinates of own hotel
    const ownHotelLatLng = {
      // @ts-expect-error: Incorrect type
      lat: this.hotelAndMarketService.hotel.hotelinfo.latitude,
      // @ts-expect-error: Incorrect type
      lng: this.hotelAndMarketService.hotel.hotelinfo.longitude,
    };

    const googleMapsConfig = {
      ...GOOGLE_MAPS_SHARED_CONFIG,
    };

    // @ts-expect-error: Incorrect type
    this.map = new google.maps.Map(
      // @ts-expect-error: Incorrect type
      document.querySelector('.google-maps-container'),
      {
        ...googleMapsConfig,

        center: {
          lat: ownHotelLatLng.lat,
          lng: ownHotelLatLng.lng,
        },
        zoom: 10,
        // Pass custom styles to the map. We want to have a grey/silver map, to have more focus on the heatmap.
        // Custom styles are generated with: https://mapstyle.withgoogle.com/
        // Note: another approach is to put greyscale filter on the whole container with CSS
        styles: getGoogleMapsStyles().BLACK_AND_WHITE,
      },
    );

    // @ts-expect-error: Incorrect type
    this.cleanupZoomControls = addZoomControls(this.map);

    // Request GeoJSON:
    // https://developers.google.com/maps/documentation/javascript/datalayer#load_geojson
    // addGeoJson documentation: https://developers.google.com/maps/documentation/javascript/reference/3.37/data?hl=en#Data.addGeoJson
    // Example: http://bl.ocks.org/zross/9893056

    // This looks a bit silly now, but allows current testing with static geojson file.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.gridFeatures?.features) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      this.map.data.addGeoJson(this.gridFeatures);

      this.updateFeatureStyles();

      this.zoom();
    }

    // https://developers.google.com/maps/documentation/javascript/events
    // https://developers.google.com/maps/documentation/javascript/reference/event#event.addListenerOnce
    // @ts-expect-error: Incorrect type
    google.maps.event.addListenerOnce(this.map, 'idle', () => {
      // @ts-expect-error: Incorrect type
      this.isMapLoading = false;
    });

    if (
      !this.args.shouldWaitToRenderEventMarkers &&
      this.args.selectedDayModel &&
      // @ts-expect-error: Incorrect type
      this.args.selectedDayModel.eventsExceptRejected
    ) {
      this.renderEventMarkers();
    }

    if (
      // @ts-expect-error: Incorrect type
      this.miHotels.originalGridResponse &&
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.miHotels.originalGridResponse.length
    ) {
      this.renderHotelMarkers();
    }
  }

  @action
  toggleDemandEvolution(): void {
    this.isDemandEvolutionVisible = !this.isDemandEvolutionVisible;
  }

  @action
  toggleMapLegend(): void {
    this.isMapLegendVisible = !this.isMapLegendVisible;

    if (this.isMapLegendInitialLoad) {
      // Enables the animations from now on
      this.isMapLegendInitialLoad = false;
    }
  }

  @action
  toggleShowAllEvents(): void {
    // @ts-expect-error: Incorrect type
    this.args.toggleShowAllEvents();
  }

  @action
  // @ts-expect-error: Incorrect type
  updateMarkers(element, [mouseOverMarkerId, mouseOutMarkerId]): void {
    if (macroCondition(isTesting())) {
      return;
    }

    if (mouseOverMarkerId) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const marker = this.markerDict[mouseOverMarkerId];

      // We need to check here is the marker is visible or not (because of the toggleable map legend items it's possible that a marker is hidden)
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (marker && marker.visible) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        marker.setZIndex(30);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        google.maps.event.trigger(marker, 'mouseover');
      }
    }
    if (mouseOutMarkerId) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const marker = this.markerDict[mouseOutMarkerId];

      // We need to check here is the marker is visible or not (because of the toggleable map legend items it's possible that a marker is hidden)
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if (marker && marker.visible) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        marker.setZIndex(10);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        google.maps.event.trigger(marker, 'mouseout');
      }
    }
  }

  <template>
    {{! @glint-nocheck }}
    {{! template-lint-disable require-presentational-children }}
    <div
      class="city-map-container
        {{if @selectedDay 'city-map-container--visible'}}
        ic-product-tour-city-map"
      {{didUpdate
        this.onMapFeaturesDataChanged
        @nbOfAvailableExtractDates
        @extractDateIndex
        this.geoData.data
      }}
      {{didUpdate
        this.onMarkerRerenderRequired
        @selectedDay
        @isDetailRequestLoading
      }}
      {{didUpdate this.onMarkerUpdateRequired @extractDateIndex}}
      {{didUpdate
        this.onEventMarkerToggleUpdate
        this.miSelections.showAllEvents
        @showAcceptedEvents
      }}
      {{didUpdate
        this.onHotelMarkerToggleUpdate
        @showSmartCompset
        @showPrimaryCompset
        @showOwnHotel
        @showSoldouts
      }}
    >
      {{#if this.isMapLoading}}
        <PrismLoadingBar />
      {{/if}}

      <div
        class="google-maps-container"
        {{didInsert this.renderMap}}
        {{didUpdate this.updateMarkers @mouseOverMarkerId @mouseOutMarkerId}}
      ></div>

      <div
        class="city-map-trigger city-map-trigger--demand-evolution flex items-center justify-center"
        role="button"
        {{on "click" (preventDefault this.toggleDemandEvolution)}}
      >
        {{t "market_insight.demand_evolution"}}
        <GeneralDropdownsDropdownArrowButton
          @isOpen={{this.isDemandEvolutionVisible}}
        />
      </div>

      <div
        class="city-map-overlay-item
          {{if this.isDemandEvolutionVisible 'fade-in' 'fade-out'}}"
      >
        <div
          class="city-map-overlay-item--demand-evolution ic-product-tour-demand-evolution"
        >
          <HotelMarketInsightDemandEvolution
            @currentExtractDate={{@currentExtractDate}}
            @extractDateIndex={{@extractDateIndex}}
            @isDetailRequestLoading={{@isDetailRequestLoading}}
            @model={{@model}}
            @nbOfAvailableExtractDates={{@nbOfAvailableExtractDates}}
            @selectedDayModel={{@selectedDayModel}}
            @updateExtractDateIndex={{@updateExtractDateIndex}}
          />
        </div>
      </div>

      <div
        class="city-map-trigger city-map-trigger--legend flex items-center justify-center"
        role="button"
        {{on "click" (preventDefault this.toggleMapLegend)}}
      >
        {{t "market_insight.map.legend.trigger"}}
        <GeneralDropdownsDropdownArrowButton
          @isOpen={{this.isMapLegendVisible}}
        />
      </div>

      {{! use the isMapLegendInitialLoad check to see if it's not the initial page load. Else you'll see a fading out legend by default when loading up the page }}
      <div
        class="city-map-overlay-item city-map-overlay-item--legend text-200--regular flex flex-col
          {{if this.isMapLegendVisible 'fade-in'}}
          {{if
            (and
              (not this.isMapLegendInitialLoad) (not this.isMapLegendVisible)
            )
            'fade-out'
          }}
          ic-product-tour-city-map-legend"
      >
        <div
          class="city-map-overlay-item--legend__item toggleable
            {{unless @showPrimaryCompset 'markers-hidden'}}"
          role="button"
          {{on "click" (fn @toggleMapVisibilityFlag "showPrimaryCompset")}}
        >
          <div
            class="compset-dot-indicator compset-dot-indicator--own-compset mr-200"
          ></div>
          {{t "market_insight.map.legend.own_compset"}}
        </div>
        {{#if @isMarketInsightFull}}
          <div
            class="city-map-overlay-item--legend__item toggleable
              {{unless @showSmartCompset 'markers-hidden'}}
              ic-product-tour-map-legend-smart-compset"
            role="button"
            {{on "click" (fn @toggleMapVisibilityFlag "showSmartCompset")}}
          >
            <div
              class="compset-dot-indicator compset-dot-indicator--smart-compset mr-200"
            ></div>

            <p class="text-200--regular flex items-center gap-100">
              {{t "market_insight.smart_compset"}}

              <GeneralIconWithTooltip
                @side="left"
                @tooltipContent={{t
                  "market_insight.kpi_explanation.smart_compset"
                }}
                @tooltipTitle={{t "market_insight.smart_compset"}}
              />
            </p>
          </div>
        {{/if}}
        <div
          class="city-map-overlay-item--legend__item toggleable
            {{unless @showSoldouts 'markers-hidden'}}"
          role="button"
          {{on "click" (fn @toggleMapVisibilityFlag "showSoldouts")}}
        >
          <div
            class="compset-dot-indicator compset-dot-indicator--soldout mr-200"
          ></div>

          <p class="text-200--regular flex items-center gap-100">
            {{t "general.soldout"}}
            <GeneralIconWithTooltip
              @side="left"
              @tooltipContent={{t "market_insight.kpi_explanation.sold_out"}}
              @tooltipTitle={{t "general.soldout"}}
            />
          </p>
        </div>
        <div
          class="city-map-overlay-item--legend__item toggleable
            {{unless @showOwnHotel 'markers-hidden'}}"
          role="button"
          {{on "click" (fn @toggleMapVisibilityFlag "showOwnHotel")}}
        >
          <div
            class="compset-dot-indicator compset-dot-indicator--own-hotel mr-200"
          ></div>
          {{t "market_insight.map.legend.your_hotel"}}
        </div>

        {{#if @isMarketInsightFull}}
          <div
            class="prism-link city-map-overlay-item--legend__item"
            role="button"
            {{on
              "click"
              (fn
                @setFocusedDetailSection
                DETAIL_PANE_DETAIL_SECTION_CARD_IDS.COMPETITORS_LIST
              )
            }}
          >
            <p class="text-200--regular">{{t
                "market_insight.view_compset_list"
              }}</p>
          </div>
        {{/if}}
        <div
          class="city-map-overlay-item--legend__item toggleable
            {{unless @showAcceptedEvents 'markers-hidden'}}"
          role="button"
          {{on "click" (fn @toggleMapVisibilityFlag "showAcceptedEvents")}}
        >
          <div class="icon-indicator events">
            <PrismIcon @color="inherit" @name="star-filled" @size="small" />
          </div>
          {{t "events.accepted_events"}}
        </div>
        <div
          class="city-map-overlay-item--legend__item toggleable
            {{unless this.miSelections.showAllEvents 'markers-hidden'}}"
          data-test-id="city-map-legend-show-all-events"
          role="button"
          {{on "click" (preventDefault this.toggleShowAllEvents)}}
        >
          <div class="icon-indicator events">
            <PrismIcon @color="inherit" @name="star-outline" @size="small" />
          </div>
          {{t "market_insight.map.legend.unaccepted_events"}}
        </div>
      </div>
    </div>

    <div class="hidden">
      {{!
  Wrapping div hides this DOM structure that is used for the city map tooltip.
  The Google Maps infowindow will retrieve this by a querySelector
  }}
      <div class="city-map__tooltip city-map__hotel-tooltip-selector">
        <p class="title">{{this.currentlyHoveredHotel.name}}</p>
        <div class="city-map__tooltip__divider"></div>
        <div class="city-map__tooltip__metric">
          <div>
            {{#if
              (or
                (not this.currentlyHoveredHotel.isOwnHotel) @isMarketInsightFull
              )
            }}
              <p class="metric-description">{{t
                  "market_insight.map.tooltip.rate"
                }}</p>
              <p class="metric-value flex items-center gap-100">
                {{this.currentlyHoveredHotelRateIndexModel.formattedRate}}
                <HotelMarketInsightTooltipsRateindexIcons
                  @rateindex={{this.currentlyHoveredHotelRateIndexModel}}
                />
              </p>
              {{#if this.currentlyHoveredHotelRateIndexModel.roomName}}
                <p class="metric-value__extra">
                  {{this.currentlyHoveredHotelRateIndexModel.roomName}}
                </p>
              {{/if}}
              <br />
            {{/if}}
            {{#let
              (get
                this.miHotels.gridResponseMapping
                this.currentlyHoveredHotelRateIndexModel.ourHotelId
              )
              as |hotel|
            }}
              {{! Note: if we're dealing with MI light: this.currentlyHoveredHotelRateIndexModel.ourHotelId won't be available for own hotel }}
              <div class="flex flex-row">
                <div class="flex flex-col">
                  <p class="text-200--regular">{{t "general.review"}}</p>
                  <p class="text-200--regular">
                    {{#if hotel.formattedReviewScore}}
                      {{hotel.formattedReviewScore}}
                    {{else}}
                      {{t "general.missing"}}
                    {{/if}}
                  </p>
                </div>
                <div class="flex flex-col">
                  <p class="text-200--regular">{{t
                      "market_insight.competitor.star_rating"
                    }}</p>
                  <div class="text-200--regular flex flex-row">
                    {{#if hotel.stars}}
                      {{#each hotel.formattedStars as |icon|}}
                        <PrismIcon @name={{icon}} @size="small" />
                      {{/each}}
                    {{else}}
                      {{t "general.missing"}}
                    {{/if}}
                  </div>
                </div>
                {{#if
                  (or
                    (not this.currentlyHoveredHotel.isOwnHotel)
                    @isMarketInsightFull
                  )
                }}
                  <div class="flex flex-col">
                    <p class="text-200--regular">{{t
                        "market_insight.competitor.similarity_score"
                      }}</p>
                    <p class="text-200--regular">
                      <p class="text-200--regular">
                        {{hotel.formattedSimilarityScore}}
                      </p>
                    </p>
                  </div>
                {{/if}}
              </div>
            {{/let}}

          </div>
        </div>
      </div>

      <div class="city-map__tooltip city-map__event-tooltip-selector">
        <p class="title">{{this.currentlyHoveredEvent.name}}</p>
        <div class="city-map__tooltip__divider"></div>
        {{#if this.currentlyHoveredEvent.displayCategory}}
          <div class="city-map__tooltip__metric">
            <p>
              <span class="mr-100">
                <PrismIcon @name={{this.currentlyHoveredEvent.icon}} />
              </span>
              {{this.currentlyHoveredEvent.displayCategory}}
            </p>
          </div>
        {{/if}}
        {{#if this.currentlyHoveredEvent.visitorsFormatted}}
          <div class="city-map__tooltip__metric">
            <p>
              <span class="mr-100">
                <PrismIcon @name="user-group" />
              </span>
              {{this.currentlyHoveredEvent.visitorsFormatted}}
            </p>
          </div>
        {{/if}}
        {{#if this.currentlyHoveredEvent.formattedDays}}
          <div class="city-map__tooltip__metric">
            <p>
              <span class="mr-100">
                <PrismIcon @name="calendar-default" />
              </span>
              {{this.currentlyHoveredEvent.formattedDays}}
            </p>
          </div>
        {{/if}}
      </div>
    </div>
  </template>
}
